import { motion } from "framer-motion";
import { track } from "@/lib/analytics";
import { IMAGES, BEACONS_URL } from "@/lib/data";

export const DJ = () => {
  return (
    <section id="dj" className="relative py-28 lg:py-36 bg-[#050505]" data-testid="dj-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-4 lg:gap-6 items-stretch">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="lg:col-span-5 flex flex-col justify-center py-6"
          >
            <p className="text-[12px] tracking-[0.3em] uppercase text-white/40 mb-5">DJ / Performance</p>
            <h2 className="font-heading uppercase tracking-tight text-white text-4xl lg:text-6xl leading-[0.95]">
              A journey in <span className="font-serif-accent italic lowercase normal-case tracking-normal text-gold">progress</span>
            </h2>
            <p className="text-white/55 mt-6 leading-relaxed text-[15px] max-w-md">
              DJing is a developing part of the ecosystem. I'm documenting the process — sets, mixes and my own productions worked into Afro, UK and club sounds. Events to follow.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              {["Sets", "Mixes", "Afro / UK / Club", "Events soon"].map((t) => (
                <span key={t} className="px-4 py-2 rounded-full border border-white/12 text-white/60 text-[12px] tracking-[0.08em]" data-testid={`dj-tag-${t}`}>{t}</span>
              ))}
            </div>
            <a
              href={BEACONS_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("dj_click", "beacons")}
              data-testid="dj-watch-cta"
              className="mt-8 inline-flex w-fit items-center px-7 py-3.5 rounded-full border border-white/25 text-white text-[13px] tracking-[0.12em] uppercase hover:bg-white/10 hover:text-gold transition-colors duration-300"
            >
              Explore My Channels
            </a>
          </motion.div>

          <div className="lg:col-span-7 grid grid-cols-2 grid-rows-2 gap-4 h-[420px] lg:h-[520px]">
            {[
              { src: IMAGES.heroStudio, cls: "row-span-2" },
              { src: IMAGES.session, cls: "" },
              { src: IMAGES.lounge, cls: "" },
            ].map((img, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                className={`group relative overflow-hidden rounded-xl border border-white/10 ${img.cls}`}
                data-testid={`dj-image-${i}`}
              >
                <img src={img.src} alt="Taps in the studio" className="w-full h-full object-cover scale-105 group-hover:scale-100 transition-transform duration-700" />
                <div className="absolute inset-0 bg-black/25 group-hover:bg-black/0 transition-colors duration-500" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DJ;
